export const voucherPaymentInternalFilter = (state) => state.voucherPaymentInternal.filter;
